import refreshIcon from "../assets/refresh-ccw.png";

export default function LoadingIcon() {
  return <img src={refreshIcon} alt="" className="size-[105px] animate-spin" />;
}
